import React, { useRef, useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Stack,
  RadioGroup,
  Input,
  FormControl,
  FormLabel,
  Text,
  Avatar,
  IconButton,
  Divider,
  InputGroup,
  InputRightElement,
  Flex
} from '@chakra-ui/react';
import {
  useDoctorsQuery,
  useReferralRulesQuery,
  useCreateReferralMutation,
  useRegisterUserToClinicMutation,
  useRegisterFamilyMemberToClinicMutation
} from '../graphql/types-and-hooks';
import queryString from 'query-string';
import { Loading } from './Loading';
import { PiStethoscopeBold } from "react-icons/pi";
//import { LoadScript, StandaloneSearchBox } from '@react-google-maps/api';
// import { usePayments } from './../hooks/usePayments';
import { useRequestReferralStore } from '../store/requestReferral';
import { useBookAppointmentStore } from '../store';
// import UserCreateSuccessModal from "./UserCreateSuccessModal";
import { FaCheck } from "react-icons/fa";
import axios from 'axios';
import PaymentStep from './PaymentStep';
import { useAlert } from './AlertProvider';
import { logError } from './logger';


// eslint-disable-next-line no-restricted-globals
const parsed = queryString.parse(location.search);

// Access environment variables
const USER_FK = parsed.cid;
const CLINIC_GROUP_CRM = parsed.gid;
const LOCATION_ID = parsed.lid;
//const APPT_ID = parsed.aid;




const RequestReferralModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1);
  // eslint-disable-next-line
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [medications, setMedications] = useState([]);
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const deliveryMethodObjRef = useRef(null);
  const [address, setAddress] = useState('');
  // eslint-disable-next-line
  const iframeRef = useRef(null);
  const [faxNumber, setfaxNumber] = useState('');
  const [specialistName, setSpecialistName] = useState('');
  const [specialistAddress, setSpecialistAddress] = useState('');
  const [reasonForReferral, setReasonForReferral] = useState('');
  const [specialNote, setSpecialNote] = useState('');
  const [createReferralMutation] = useCreateReferralMutation();
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [isAddressValidated, setIsAddressValidated] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [email, setemail] = useState('');
  const [emailError, setEmailError] = useState('');
  const { showAlert } = useAlert();

  const [
    registerUserToClinicMutation,
  ] = useRegisterUserToClinicMutation();

  const [
    registerFamilyMemberToClinicMutation,
  ] = useRegisterFamilyMemberToClinicMutation();

  useEffect(() => {
    if (isOpen) {
      // Send a message to the parent window to scroll to the top
      window.parent.postMessage({ action: 'scrollToTop' }, '*');
    }
  }, [isOpen]);


  // eslint-disable-next-line
  const [patient, doctor, patientId, setData, resetData] = useRequestReferralStore((state) => [
    state.patient,
    state.doctor,
    state.patientId,
    state.setData,
    state.resetData,
  ]);

  // eslint-disable-next-line
  const [patient1, clinic1, setData1, resetData1] = useBookAppointmentStore((state) => [
    state.patient,
    state.clinic,
    state.setData,
    state.resetData,
  ]);

  const { data: ReferralRulesData } = useReferralRulesQuery({
    variables: {
      input: {
        clinic_group_crm: CLINIC_GROUP_CRM,
        user_fk: USER_FK,
      },
    },
  });

  const handleSuccessModalClose = () => {
    setSuccessModalOpen(false);
    onClose();

  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setemail(newEmail);

    if (!validateEmail(newEmail)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };


  const registerPatient = async () => {
    let id;
    if (patient1.family_member_key) {
      try {
        const result = await registerFamilyMemberToClinicMutation({
          variables: {
            input: {
              clinic_group_crm: CLINIC_GROUP_CRM,
              user_fk: USER_FK,
              location_id: LOCATION_ID,
              family_member_key: parseInt(patient1.family_member_key),
            },
          },
        });

        id = result?.data?.registerFamilyMemberToClinic?.patient_id;

      } catch (error) {
        logError("bookAppointmentRegisterError", error);
        console.error("bookAppointmentRegisterError", JSON.stringify(error, null, 2));
      }
    } else {
      try {
        const result = await registerUserToClinicMutation({
          variables: {
            input: {
              clinic_group_crm: CLINIC_GROUP_CRM,
              user_fk: USER_FK,
              location_id: LOCATION_ID,
            },
          },
        });

        id = result?.data?.registerUserToClinic?.patient_id;


        if (!id) {
          throw new Error('Failed to register user to clinic.');
        }
      } catch (error) {
        logError("bookAppointmentRegisterError", error);
        console.error("bookAppointmentRegisterError", JSON.stringify(error, null, 2));
      }
    }

    setData({
      patientId: id,
    });
    return id;


  };

  // eslint-disable-next-line
  const addMedication = () => {
    setMedications([...medications, { name: '', dosage: '', times: '' }]);
  };

  // eslint-disable-next-line
  const handleMedicationChange = (index, field, value) => {
    const newMedications = medications.map((med, i) =>
      i === index ? { ...med, [field]: value } : med
    );
    setMedications(newMedications);
  };

  const handleNext = () => setStep(step + 1);
  const handlePrevious = () => setStep(step - 1);

  const handleDoctorSelect = async (doctor) => {
    setSelectedDoctor(doctor);
    setData({
      doctor: doctor
    });

    // Wait for registerPatient to complete
    const id = await registerPatient();

    // Now patientId should be set
    if (id) {
      handleNext();
    } else {
      showAlert({
        severity: "error",
        title: "Whoops",
        message: "Failed to register the patient. Please try again."
      });
    }
  };

  // const handleSubmit = () => {
  //   // console.log('Form Submitted');
  //   // onClose();
  //   setSuccessModalOpen(true);

  // };

  // eslint-disable-next-line
  const handlePlaceChanged = (ref) => {
    const places = ref.getPlaces();
    if (places.length === 1) {
      const place = places[0];
      setAddress(place.formatted_address);
    }
  };


  const handleAddressInput = async (address) => {
    if (address.length >= 15) {
      try {
        const response = await axios.post('https://api.staging.app.familydoctor.com.au/location/validate', { address });

        const result = response.data.result;
        const addressComponents = result.address.addressComponents;

        // Check if essential components like route, locality, and postal code are confirmed
        const hasConfirmedRoute = addressComponents.some(
          (component) => component.componentType === 'route' && component.confirmationLevel === 'CONFIRMED'
        );
        const hasConfirmedLocality = addressComponents.some(
          (component) => component.componentType === 'locality' && component.confirmationLevel === 'CONFIRMED'
        );
        const hasConfirmedPostalCode = addressComponents.some(
          (component) => component.componentType === 'postal_code' && component.confirmationLevel === 'CONFIRMED'
        );

        if (hasConfirmedRoute && hasConfirmedLocality && hasConfirmedPostalCode) {
          const formattedAddress = result.address.formattedAddress;
          setAddress(formattedAddress);
          setValidationError('');
          // console.log('Address validated:', formattedAddress);
          setIsAddressValidated(true);
          setValidationError(formattedAddress);
        } else {
          setAddress(null);
          setIsAddressValidated(false);
          setValidationError('Invalid address. Please enter a valid address.');
        }
      } catch (error) {
        logError('Error validating address', error);
        console.error('Error validating address:', error);
        setAddress(null);
        setIsAddressValidated(false);
        setValidationError('Invalid address. Please enter a valid address.');
      }
    }
  };

  const handleSuccess = async (id: string) => {

    console.log("Patient: ", patient)

    let deliveryMthdData = '';

    if (deliveryMethod.toLowerCase().includes('fax')) {
      deliveryMthdData = faxNumber;
    } else if (deliveryMethod.toLowerCase().includes('email')) {
      deliveryMthdData = email;
    } else if (deliveryMethod.toLowerCase().includes('post')) {
      deliveryMthdData = address;
    } else if (deliveryMethod.toLowerCase().includes('send to pharmacy')) {
      deliveryMthdData = address;
    } else if (deliveryMethod.toLowerCase().includes('send to home')) {
      deliveryMthdData = address;
    } else {
      deliveryMthdData = null;
    }

    const deliveryMethodIndex = ReferralRulesData.referralRules.referral_delivery_mthds.findIndex(
      method => method.delivery_desc.toLowerCase() === deliveryMethod.toLowerCase()
  );

    try {
      await createReferralMutation({
        variables: {
          input: {
            clinic_group_crm: CLINIC_GROUP_CRM,
            user_fk: USER_FK,
            location_id: LOCATION_ID,
            patient_id: patientId,
            first_name: patient1.first_name,
            last_name: patient1.last_name,
            dob: patient1.dob,
            mobile_phone: patient1.contact_number,
            doctor_id: doctor.doctor_id,
            payment_id: `${id}`,
            delivery_mthd: `${deliveryMethodIndex}`,
            delivery_mthd_data: deliveryMthdData ?? "None",
            spinfo: [
              {
                sname: specialistName,
                addressSp: specialistAddress,
                refreason: reasonForReferral,
                specialnote: specialNote,
              },
            ],
          },
        },
      });

      // GTAG EVENT
      (window as any).gtag('event', 'referral', {
        clinic_group_crm: CLINIC_GROUP_CRM,
        user_fk: USER_FK,
        location_id: LOCATION_ID,
      });
      setSuccessModalOpen(true);
    } catch (error) {
      console.log(error);


    }
  };

  const handleError = () => console.log("error");

  // eslint-disable-next-line
  // const params = useMemo(() => ({
  //   req: 'tyro_callerid',
  //   kiosk: clinic1?.kiosk_serial_no,
  //   pname: `${patient1?.first_name} ${patient1?.last_name}`,
  //   pid: patientId,
  //   pmethod: '4',
  //   lid: `${LOCATION_ID}`,
  //   did: doctor?.doctor_id,
  //   aptypeid: '0',
  //   bid: '0',
  //   mac: '',
  //   room_name: '',
  // }), [clinic1?.kiosk_serial_no, patient1?.first_name, patient1?.last_name, patientId, LOCATION_ID, doctor?.doctor_id]);

  // const successCallback = useCallback((id: string) => {
  //   handleSuccess(id);  // or whatever logic you want on success
  // }, [handleSuccess]);

  // const errorCallback = useCallback(() => {
  //   handleError();  // or whatever logic you want on error
  // }, [handleError]);

  // const { injectedScript, generatePaymentUrl } = usePayments({
  //   params,
  //   successCallback,
  //   errorCallback,
  // });

  const DoctorsList = () => {
    const { data: doctorsData, loading: doctorsLoading, error: doctorsError } = useDoctorsQuery({
      variables: {
        input: {
          clinic_group_crm: CLINIC_GROUP_CRM,
          user_fk: USER_FK,
          location_id: LOCATION_ID,
        },
        filters: {
          allow_online_app: '1',
          allow_referrals: '1',
        },
      },
    });

    if (doctorsLoading) return <Loading />;
    if (doctorsError) return <Text>Error loading doctors: {doctorsError.message}</Text>;

    return (
      <div>
        {doctorsData?.doctors.map((doctor) => (
          <Box p={2} display="flex" flexDirection="row" key={doctor.doctor_id} justifyContent={"space-between"} onClick={() => handleDoctorSelect(doctor)} boxShadow="md" borderRadius={10} mt={2} cursor="pointer"
            borderWidth="1px">
            <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center"><Avatar
              name={doctor.display_name}
              size="md"
              src={doctor.image}
            />

              <Text fontWeight="bold" color={'gray'} ml={4}>{doctor.display_name}</Text>

            </Box>
            <IconButton
              isRound={true}
              variant='solid'
              bg="#B92F2F"
              aria-label='Done'
              fontSize='20px'
              onClick={() => handleDoctorSelect(doctor)}
              icon={<PiStethoscopeBold color="#fff" />}
            />
          </Box>
        ))}
      </div>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" blockScrollOnMount={false} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent >
        <ModalCloseButton />

        {step === 1 && (
          <>
            <Alert
              status='warning'
              variant="subtle"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              borderTopRadius={"10px"}
              p={5}
            >
              <AlertIcon boxSize="40px" mr={0} />
              <AlertTitle mt={4} mb={1} fontSize="lg">
                Disclaimer
              </AlertTitle>
              <AlertDescription maxWidth="sm">
                <p dangerouslySetInnerHTML={{ __html: ReferralRulesData?.referralRules?.referral_msg }} />
              </AlertDescription>
            </Alert>
            <ModalFooter>
              <Button variant="ghost" borderRadius={30} size='sm' onClick={onClose}>
                Cancel
              </Button>
              <Button variant='solid'
                size='sm'
                bg="#B92F2F" color="#fff"
                aria-label='Done'
                fontSize='sm'
                borderRadius={30}
                onClick={handleNext}
                marginLeft={5}>
                Next
              </Button>
            </ModalFooter>
          </>
        )}

        {step === 2 && (
          <>
            <ModalHeader>Please select your Doctor</ModalHeader>
            <ModalBody>
              <Stack >
                <DoctorsList />
              </Stack>
            </ModalBody>
            <ModalFooter>
              <Button variant="ghost" onClick={handlePrevious}>
                Back
              </Button>
            </ModalFooter>
          </>
        )}

        {step === 3 && (
          <>
            <ModalHeader>Please enter Specialist Details</ModalHeader>
            <ModalBody>
              <Stack spacing={4}>

                <Box >
                  <FormControl>
                    <FormLabel>Specialist name</FormLabel>
                    <Input
                      variant='filled'
                      value={specialistName}
                      onChange={(e) => setSpecialistName(e.target.value)}
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Specialist address</FormLabel>

                    <Box flexDirection={'row'}>
                      <InputGroup>
                        <Input

                          // value={specialistAddress}
                          variant='filled'
                          onBlur={(e) => {
                            const newAddress = e.target.value;
                            setSpecialistAddress(e.target.value);
                            setAddress(newAddress);
                            handleAddressInput(newAddress);
                          }}
                        />
                        {isAddressValidated && (
                          <InputRightElement >
                            <FaCheck color="green" />
                          </InputRightElement>
                        )}
                      </InputGroup>
                    </Box>
                    {validationError && (
                      <Text color="red" fontSize="sm" mt={2} textAlign={'center'}>
                        {validationError}
                      </Text>
                    )}
                  </FormControl>
                  <FormControl>
                    <FormLabel>Reason for referral</FormLabel>
                    <Input
                      variant='filled'
                      value={reasonForReferral}
                      onChange={(e) => setReasonForReferral(e.target.value)}
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Special note</FormLabel>
                    <Input
                      variant='filled'
                      value={specialNote}
                      onChange={(e) => setSpecialNote(e.target.value)}
                    />
                  </FormControl>
                </Box>


              </Stack>
            </ModalBody>
            <ModalFooter>
              <Button variant="ghost" borderRadius={30} size='sm' onClick={handlePrevious}>
                Back
              </Button>
              <Button variant='solid'
                size='sm'
                bg="#B92F2F" color="#fff"
                aria-label='Done'
                fontSize='sm'
                borderRadius={30}
                onClick={handleNext}
                marginLeft={5}
                isDisabled={
                  !specialistName || !specialistAddress || !reasonForReferral
                }>
                Next
              </Button>
            </ModalFooter>
          </>
        )}

        {step === 4 && (
          <>
            <ModalHeader>Please choose Delivery Method</ModalHeader>
            <ModalBody>
              <RadioGroup onChange={setDeliveryMethod} value={deliveryMethod}>
                <Stack direction="column" spacing={4}>
                  {ReferralRulesData.referralRules.referral_delivery_mthds.map((method, index) => {
                    if (method.enabled === '1') {
                      return (
                        <Box
                          key={index}
                          as="button"
                          cursor="pointer"
                          borderWidth="1px"
                          borderRadius="md"
                          boxShadow="md"
                          fontWeight={'bold'}
                          p={'10px'}
                          bg={deliveryMethod === method.delivery_desc.toLowerCase() ? '#B92F2F' : 'white'}
                          color={deliveryMethod === method.delivery_desc.toLowerCase() ? 'white' : 'black'}
                          borderColor={deliveryMethod === method.delivery_desc.toLowerCase() ? 'teal.600' : 'gray.200'}
                          _hover={{ borderColor: 'teal.600' }}
                          onClick={() => {
                            setDeliveryMethod(method.delivery_desc.toLowerCase())
                            deliveryMethodObjRef.current = method;
                          }}
                        >
                          {method.delivery_desc} (${method.fee})
                          {(method.delivery_desc.toLowerCase() === 'fax' && deliveryMethod === 'fax') && (
                            <Input
                              bg="white"
                              color="black"
                              value={faxNumber}
                              placeholder="Enter Fax No."
                              mt={2}
                              onChange={(e) => setfaxNumber(e.target.value)}
                            />
                          )}
                          {(method.delivery_desc.toLowerCase() === 'email' && deliveryMethod === 'email') && (
                            <>
                              <Input
                                bg="white"
                                color="black"
                                value={email}
                                placeholder="Enter your Email."
                                mt={2}
                                onChange={handleEmailChange}
                              />
                              {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                            </>
                          )}
                          {(method.delivery_desc.toLowerCase() === 'email [urgent]' && deliveryMethod === 'email [urgent]') && (
                            <>
                              <Input
                                bg="white"
                                color="black"
                                value={email}
                                placeholder="Enter your Email."
                                mt={2}
                                onChange={handleEmailChange}
                              />
                              {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                            </>
                          )}
                          {(method.delivery_desc.toLowerCase() === 'email to specialist' && deliveryMethod === 'email to specialist') && (
                            <>
                              <Input
                                bg="white"
                                color="black"
                                value={email}
                                placeholder="Enter your Email."
                                mt={2}
                                onChange={handleEmailChange}
                              />
                              {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                            </>
                          )}
                          {(method.delivery_desc.toLowerCase() === 'email to specialist [urgent]' && deliveryMethod === 'email to specialist [urgent]') && (
                            <>
                              <Input
                                bg="white"
                                color="black"
                                value={email}
                                placeholder="Enter your Email."
                                mt={2}
                                onChange={handleEmailChange}
                              />
                              {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                            </>
                          )}

                          {(method.delivery_desc.toLowerCase() === 'post' && deliveryMethod === 'post') && (
                            <>
                              <Box flexDirection={'row'}>
                                <InputGroup>
                                  <Input
                                    placeholder="Enter Address"
                                    mt={2}
                                    bg="white"
                                    color="black"
                                    onChange={(e) => {
                                      const newAddress = e.target.value;
                                      setAddress(newAddress);
                                      handleAddressInput(newAddress);
                                    }}
                                  />
                                  {isAddressValidated && (
                                    <InputRightElement mt={2}>
                                      <FaCheck color="green" />
                                    </InputRightElement>
                                  )}
                                </InputGroup>
                              </Box>
                              {validationError && (
                                <Text color="#fff" fontSize="sm" mt={2} >
                                  {validationError}
                                </Text>
                              )}
                            </>

                          )}
                          {(method.delivery_desc.toLowerCase() === 'post [urgent]' && deliveryMethod === 'post [urgent]') && (
                            <>
                              <Box flexDirection={'row'}>
                                <InputGroup>
                                  <Input
                                    placeholder="Enter Address"
                                    mt={2}
                                    bg="white"
                                    color="black"
                                    onChange={(e) => {
                                      const newAddress = e.target.value;
                                      setAddress(newAddress);
                                      handleAddressInput(newAddress);
                                    }}
                                  />
                                  {isAddressValidated && (
                                    <InputRightElement mt={2}>
                                      <FaCheck color="green" />
                                    </InputRightElement>
                                  )}
                                </InputGroup>
                              </Box>
                              {validationError && (
                                <Text color="#fff" fontSize="sm" mt={2} >
                                  {validationError}
                                </Text>
                              )}
                            </>

                          )}
                          {(method.delivery_desc.toLowerCase() === 'send to home' && deliveryMethod === 'send to home') && (
                            <>
                              <Box flexDirection={'row'}>
                                <InputGroup>
                                  <Input
                                    placeholder="Enter Address"
                                    mt={2}
                                    bg="white"
                                    color="black"
                                    onChange={(e) => {
                                      const newAddress = e.target.value;
                                      setAddress(newAddress);
                                      handleAddressInput(newAddress);
                                    }}
                                  />
                                  {isAddressValidated && (
                                    <InputRightElement mt={2}>
                                      <FaCheck color="green" />
                                    </InputRightElement>
                                  )}
                                </InputGroup>
                              </Box>
                              {validationError && (
                                <Text color="#fff" fontSize="sm" mt={2} >
                                  {validationError}
                                </Text>
                              )}
                            </>

                          )}
                          {(method.delivery_desc.toLowerCase() === 'send to home [urgent]' && deliveryMethod === 'send to home [urgent]') && (
                            <>
                              <Box flexDirection={'row'}>
                                <InputGroup>
                                  <Input
                                    placeholder="Enter Address"
                                    mt={2}
                                    bg="white"
                                    color="black"
                                    onChange={(e) => {
                                      const newAddress = e.target.value;
                                      setAddress(newAddress);
                                      handleAddressInput(newAddress);
                                    }}
                                  />
                                  {isAddressValidated && (
                                    <InputRightElement mt={2}>
                                      <FaCheck color="green" />
                                    </InputRightElement>
                                  )}
                                </InputGroup>
                              </Box>
                              {validationError && (
                                <Text color="#fff" fontSize="sm" mt={2} >
                                  {validationError}
                                </Text>
                              )}
                            </>

                          )}
                          {(method.delivery_desc.toLowerCase() === 'send to Pharmacy' && deliveryMethod === 'send to Pharmacy') && (
                            <>
                              <Box flexDirection={'row'}>
                                <InputGroup>
                                  <Input
                                    placeholder="Enter Address"
                                    mt={2}
                                    bg="white"
                                    color="black"
                                    onChange={(e) => {
                                      const newAddress = e.target.value;
                                      setAddress(newAddress);
                                      handleAddressInput(newAddress);
                                    }}
                                  />
                                  {isAddressValidated && (
                                    <InputRightElement mt={2}>
                                      <FaCheck color="green" />
                                    </InputRightElement>
                                  )}
                                </InputGroup>
                              </Box>
                              {validationError && (
                                <Text color="#fff" fontSize="sm" mt={2} >
                                  {validationError}
                                </Text>
                              )}
                            </>

                          )}
                          {(method.delivery_desc.toLowerCase() === 'send to Pharmacy [urgent]' && deliveryMethod === 'send to Pharmacy [urgent]') && (
                            <>
                              <Box flexDirection={'row'}>
                                <InputGroup>
                                  <Input
                                    placeholder="Enter Address"
                                    mt={2}
                                    bg="white"
                                    color="black"
                                    onChange={(e) => {
                                      const newAddress = e.target.value;
                                      setAddress(newAddress);
                                      handleAddressInput(newAddress);
                                    }}
                                  />
                                  {isAddressValidated && (
                                    <InputRightElement mt={2}>
                                      <FaCheck color="green" />
                                    </InputRightElement>
                                  )}
                                </InputGroup>
                              </Box>
                              {validationError && (
                                <Text color="#fff" fontSize="sm" mt={2} >
                                  {validationError}
                                </Text>
                              )}
                            </>

                          )}
                        </Box>
                      );
                    }
                    return null;
                  })}
                </Stack>
              </RadioGroup>
            </ModalBody>
            <ModalFooter>
              <Box flex="1" textAlign="left">
                <Text fontSize="lg" fontWeight={'bold'} color="red.500">
                  {ReferralRulesData.referralRules.referral_delivery_mthds.map((method) => {
                    if (method.delivery_desc.toLowerCase() === deliveryMethod) {
                      return `$${method.fee}`;
                    }
                    return null;
                  })}
                </Text>
              </Box>
              <Button variant="ghost"
                aria-label='Done'
                fontSize='sm'
                size='sm'
                borderRadius={30} onClick={handlePrevious}>
                Back
              </Button>
              <Button variant='solid'
                size='sm'
                bg="#B92F2F" color="#fff"
                aria-label='Done'
                fontSize='sm'
                borderRadius={30}
                ml={"5px"}
                onClick={handleNext}
                isDisabled={
                  (deliveryMethod === 'fax' && !faxNumber)
                }>
                Make Payment
              </Button>
            </ModalFooter>
          </>




        )}

        {step === 5 && (
          <>
            <ModalHeader>Payment Confirmation</ModalHeader>
            <ModalBody>
              <Text mb={2}>Please confirm the details below before proceeding to payment</Text>

              <Box mb={4}>
                <Text fontWeight="bold">Patient Details</Text>
                <Text ml={3}>Full Name: {patient1?.first_name} {patient1?.last_name}</Text>
                <Text ml={3}>Date of Birth: {patient1?.dob}</Text>
              </Box>
              <Divider />

              <Box mb={4} mt={4}>
                <Text fontWeight="bold">Doctor Details</Text>
                <Text ml={3}>Name: {doctor?.display_name}</Text>
                <Text ml={3}>Clinic: {clinic1?.location_display_name}</Text>
              </Box>
              <Divider />

              <Box mb={4} mt={4} bg={"#f0f0f0"} borderWidth="1px" boxShadow={"md"} p={5} borderRadius={8}>
                <Text ml={3} fontWeight="bold">Specialist Details</Text>
                <Text ml={3}>Specialist Name: {specialistName}</Text>
                <Text ml={3}>Specialist Address: {specialistAddress}</Text>
                <Text ml={3}>Reason for Referral: {reasonForReferral}</Text>
                <Text ml={3}>Special Note: {specialNote}</Text>
              </Box>
              <Divider />

              <Box mb={4} mt={4}>
                <Text fontWeight="bold">Your Order</Text>
                <Text ml={3}>Delivery Method: {deliveryMethod}</Text>
                {deliveryMethod.toLowerCase().includes('fax') && (
                  <Text ml={3}>Fax Number: {faxNumber}</Text>
                )}
                {deliveryMethod.toLowerCase().includes('email') && (
                  <Text ml={3}>E mail: {email}</Text>
                )}
                {deliveryMethod.toLowerCase().includes('post') && (
                  <Text ml={3}>Post Address: {address}</Text>
                )}
                {deliveryMethod.toLowerCase().includes('send to pharmacy') && (
                  <Text ml={3}>Post Address: {address}</Text>
                )}
                {deliveryMethod.toLowerCase().includes('send to home') && (
                  <Text ml={3}>Post Address: {address}</Text>
                )}
                <Text fontSize="lg" fontWeight={'bold'} ml={3}> Total Cost :
                  {ReferralRulesData.referralRules.referral_delivery_mthds.map((method) => {
                    if (method.delivery_desc.toLowerCase() === deliveryMethod) {
                      return `$${method.fee}`;
                    }
                    return null;
                  })}
                </Text>
              </Box>


              <Text mb={4}>If the details are correct, please proceed to payment.</Text>


            </ModalBody>
            <ModalFooter>
              <Button
                variant="ghost"
                aria-label="Back"
                fontSize="sm"
                size="sm"
                borderRadius={30}
                onClick={handlePrevious}
              >
                Back
              </Button>
              <Button
                variant="solid"
                size="sm"
                bg="#B92F2F"
                color="#fff"
                aria-label="Done"
                fontSize="sm"
                borderRadius={30}
                ml={'5px'}
                onClick={handleNext}
              >
                Proceed to Payment
              </Button>
            </ModalFooter>
          </>
        )}
        {step === 6 && (
          <>
            <ModalHeader>Enter card details</ModalHeader>

            <ModalBody>
              <PaymentStep
                clinic={clinic1}
                patient={patient1}
                patientId={patientId}
                doctor={doctor}
                locationId={LOCATION_ID}
                pmethod={'4'}
                aptypeid={'0'}
                bid={'0'}
                fees={deliveryMethodObjRef.current.fee}
                isSuccessModalOpen={isSuccessModalOpen}
                onSuccessModalClose={handleSuccessModalClose}
                handleSuccess={handleSuccess}
                handleError={handleError}
                handlePrevious={handlePrevious}
              />
              <Flex justify='space-between' mb={5}>

                <Button variant="ghost" aria-label="Back" fontSize="sm" size="sm" borderRadius={30} onClick={handlePrevious}>
                  Back
                </Button>
                <Button bg="#B92F2F"
                  color="#fff" aria-label="Back" fontSize="sm" size="sm" borderRadius={30} onClick={onClose}>
                  Cancel Payment
                </Button></Flex>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default RequestReferralModal;
